import { useState, useEffect } from "react";
import { AskedQuestionsTable } from "./AskedQuestionsTable";
import { useParams } from "react-router-dom";
import "./CollectionAskedQuestions.css";

export const CollectionAskedQuestions = () => {
  const { collectionId } = useParams();

  return (
    <div id="collection-asked-questions">
      <div className="page-title">Asked Questions</div>

      <div className="collection-asked-questions-container">
        <AskedQuestionsTable collectionId={collectionId} />
      </div>
    </div>
  );
};
